import {
  callApiLayDanhSachNhomChucVu,
  callApiTaoNhomChucVu,
  callApiCapNhatNhomChucVu,
  callApiXoaNhomChucVu,
  callApiLayChiTietNhomChucVu,
} from "@/api/nhom-chuc-vu";

const layDanhSachChucVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachNhomChucVu(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_DANH_SACH_CHUC_VU_THANH_CONG", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

const layChiTietNhomChucVu = (context, payload) => {
  callApiLayChiTietNhomChucVu(payload)
    .then((response) => {
      context.commit("LAY_CHI_TIET_CHUC_VU_THANH_CONG", response.data);
    })
    .catch((error) => {
      console.error(error);
    });
};

const taoNhomChucVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoNhomChucVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

const capNhatNhomChucVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatNhomChucVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

const xoaNhomChucVu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaNhomChucVu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

export default {
  layDanhSachChucVu,
  taoNhomChucVu,
  capNhatNhomChucVu,
  xoaNhomChucVu,
  layChiTietNhomChucVu,
};
